import React, { useMemo } from "react";
import { useJwt } from "react-jwt";
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from "react-router-dom";

import { useAuth } from "../hooks/auth";

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<IRouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user, token } = useAuth();
  const { isExpired } = useJwt(token);

  const showRoute = useMemo(
    () => !isPrivate || (isPrivate && !!user && !isExpired),
    [isExpired, isPrivate, user]
  );

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return showRoute ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? "/login" : "/app",
              state: { form: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
